"use client"

import { useEffect, useState } from "react"
import Image from "next/image"

// Define the brand logos array to use in multiple places
const brandLogos = [
  { name: "Whirlpool", src: "/images/brands/whirlpool-logo.png", width: 120, height: 40 },
  { name: "Maytag", src: "/images/brands/maytag-logo.png", width: 120, height: 40 },
  { name: "LG", src: "/images/brands/lg-logo.png", width: 120, height: 40 },
  { name: "KitchenAid", src: "/images/brands/kitchenaid-logo.png", width: 120, height: 35 },
  { name: "Sub-Zero", src: "/images/brands/subzero-logo.png", width: 120, height: 35 },
  { name: "Wolf", src: "/images/brands/wolf-logo.png", width: 120, height: 40 },
  { name: "Thermador", src: "/images/brands/thermador-logo.jpeg", width: 120, height: 40 },
  { name: "Sharp", src: "/images/brands/sharp-logo.png", width: 120, height: 35 },
  { name: "Haier", src: "/images/brands/haier-logo.png", width: 120, height: 40 },
  { name: "Kenmore", src: "/images/brands/kenmore-logo.svg", width: 120, height: 40 },
  { name: "Beko", src: "/images/brands/beko-logo.png", width: 120, height: 40 },
  { name: "Fisher & Paykel", src: "/images/brands/fisher-paykel-logo.png", width: 120, height: 30 },
  { name: "Electrolux", src: "/images/brands/electrolux-logo.png", width: 120, height: 40 },
  { name: "Bosch", src: "/images/brands/bosch-logo.png", width: 120, height: 40 },
  { name: "Frigidaire", src: "/images/brands/frigidaire-logo.png", width: 120, height: 35 },
  { name: "Gaggenau", src: "/images/brands/gaggenau-logo.png", width: 120, height: 35 },
  { name: "JennAir", src: "/images/brands/jennair-logo.png", width: 120, height: 35 },
  { name: "GE", src: "/images/brands/ge-logo.png", width: 120, height: 40 },
  { name: "Amana", src: "/images/brands/amana-logo.png", width: 120, height: 40 },
  { name: "Samsung", src: "/images/brands/samsung-logo.png", width: 120, height: 40 },
  { name: "Miele", src: "/images/brands/miele-logo.png", width: 120, height: 40 },
  { name: "Viking", src: "/images/brands/viking-logo.jpeg", width: 120, height: 40 },
  { name: "Liebherr", src: "/images/brands/liebherr-logo.png", width: 120, height: 40 },
  { name: "Speed Queen", src: "/images/brands/speed-queen-logo.png", width: 120, height: 40 },
]

export function SimpleSlidingBrandLogos() {
  const [isMobile, setIsMobile] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  if (!isClient) {
    return null // Return nothing during SSR to prevent hydration mismatch
  }

  return (
    <div className="w-full overflow-hidden bg-gray-50 py-6">
      <div className="relative">
        {/* Mobile Carousel */}
        {isMobile ? (
          <div className="overflow-x-auto pb-4">
            <div className="flex space-x-4 px-4 min-w-max">
              {brandLogos.map((brand, index) => (
                <div key={index} className="flex flex-col items-center justify-center">
                  <div className="h-16 flex items-center justify-center bg-white rounded-lg shadow-sm p-2 w-28">
                    <Image
                      src={brand.src || "/placeholder.svg"}
                      alt={`${brand.name} logo`}
                      width={brand.width}
                      height={brand.height}
                      loading="lazy"
                      sizes="(max-width: 768px) 96px, 120px"
                      style={{ height: "auto", width: "auto", maxHeight: "2.5rem", objectFit: "contain" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* Desktop Animation */
          <div className="flex space-x-8 animate-scroll">
            <div className="flex space-x-8 min-w-max">
              {brandLogos.map((brand, index) => (
                <div key={index} className="flex items-center justify-center">
                  <div className="h-16 flex items-center justify-center bg-white rounded-lg shadow-sm p-3 w-32">
                    <Image
                      src={brand.src || "/placeholder.svg"}
                      alt={`${brand.name} logo`}
                      width={brand.width}
                      height={brand.height}
                      loading="lazy"
                      sizes="120px"
                      style={{ height: "auto", width: "auto", maxHeight: "2.5rem", objectFit: "contain" }}
                    />
                  </div>
                </div>
              ))}
            </div>
            {/* Duplicate for seamless looping */}
            <div className="flex space-x-8 min-w-max">
              {brandLogos.map((brand, index) => (
                <div key={`dup-${index}`} className="flex items-center justify-center">
                  <div className="h-16 flex items-center justify-center bg-white rounded-lg shadow-sm p-3 w-32">
                    <Image
                      src={brand.src || "/placeholder.svg"}
                      alt={`${brand.name} logo`}
                      width={brand.width}
                      height={brand.height}
                      loading="lazy"
                      sizes="120px"
                      style={{ height: "auto", width: "auto", maxHeight: "2.5rem", objectFit: "contain" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
